import React from 'react';

export default (NotificationTemplate, DefaultButton) => {
	return function challengeSubmissionStateChangedNotification(props) {
		return <NotificationTemplate {...props} button={DefaultButton} disableConfetti={true} disableTitle={true} />;
	};
};
